export default {
  aliados: [],
  table_headers: [
    { title: 'CÓDIGO', sortKey: 'id' },
    { title: 'TIPO CUENTA', sortKey: 'tipoCuenta' },
    { title: 'NOMBRE', sortKey: 'nombre' },
    { title: 'TIPO IDENTIFICACIÓN', sortKey: 'tipoIdentificacion' },
    { title: 'NIT', sortKey: 'nit' },
    { title: 'PAÍS', sortKey: 'pais' },
    { title: 'DEPARTAMENTO', sortKey: 'departamento' },
    { title: 'CIUDAD', sortKey: 'ciudad' },
    { title: 'ACCIONES', sortKey: '' }
  ],
  idAliadoModificado: null
}
